<template>
	<div class="intelligent-cnc-workshop-list">
		<div class="intelligent-cnc-workshop-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">Intelligent CNC workshop</span>
			</div>

			<div class="list">
				<ul class="item-one">
					<li class="x-flow"><img :src="solution_image_01" alt="Xhorse"/></li>
					<li class="x-flow"><img :src="solution_image_02" alt="Xhorse"/></li>
				</ul>

				<h3>Features of unmanned workshop:</h3>

				<ul class="item-two">
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Digital twin virtual factory;</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Intelligent distribution and distribution of processing orders;</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Real time monitoring of machining status;</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Real time monitoring of equipment health status, etc;</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Intelligent human-computer interaction;</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Intelligent energy control system;</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Robot automatic loading and unloading.</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_ime_01.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_ime_02.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02,
            };
        }
    }

</script>

<style scoped="">
	.list > h3 {
		width: 100%;
		height: 1.5rem;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
		margin-top: 2.75rem;
	}

	.item-two {
		margin-top: 2.75rem;
	}

	.item-one > li > img {
		width: 100%;
	}

	.item-one > li:nth-child(1) {
		width: 29.75rem;
	}

	.item-one > li:nth-child(2) {
		width: calc(100% - 29.75rem - 1.5rem);
		margin-left: 1.5rem;
	}

	.item-one {
		width: 100%;
	}

	.list > ul {
		width: 100%;
	}

	.list > ul:nth-child(1) {
		height: 20rem;
	}

	.list > ul:nth-child(2) {
		height: 12rem;
	}

	.intelligent-cnc-workshop-con {
		width: 48.125rem;
		border: none;
		margin-left: 0;
	}

	.intelligent-cnc-workshop-list {
		width: 100%;
		height: 48.125rem;
		border: none;
	}

	.ll {
		width: calc(100% - .625rem);
		border: none;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
		margin-bottom: 1.375rem;
	}

	.dot {
		width: .625rem;
		text-align: left;
	}

	.list {
		width: 54.5rem;
		height: 32.625rem;
		border: none;
		margin-left: 7rem;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}

	.warnning {

		width: 100%;
		height: 100px;
		margin: 0 auto;
		text-align: center;
		font-style: oblique;
		font-size: 64px;
		font-family: "Open Sans";
		margin-top: 44px;
		margin-bottom: 44px;

	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-intelligent-cnc-workshop.vue